if (!window.B2BTieredPricing) {
    window.B2BTieredPricing = class B2BTieredPricing {
      constructor(container) {
        this.container = container;
        if (!this.container || this.container.dataset.initialized) return;
        this.container.dataset.initialized = true;
        this.init();
      }
  
      async init() {
        await customElements.whenDefined('media-gallery');
        const tiersDataElement = this.container.querySelector('[data-b2b-tiers-json]');
        const cartOptionsEl = this.container.querySelector('[data-cart-render-options]');
        try {
          this.priceTiers = JSON.parse(tiersDataElement.textContent).sort((a, b) => a.qty - b.qty);
          this.cartRenderOptions = JSON.parse(cartOptionsEl.textContent);
        } catch (e) {
          this.priceTiers = [];
          this.cartRenderOptions = {};
        }
        
        this.currencyCode = this.container.dataset.currencyCode;
        this.priceUnit = this.container.dataset.priceUnit || '';
        this.isPercentageMode = this.priceTiers.length > 0 && this.priceTiers[0].hasOwnProperty('discount_percent');
        this.defaultBasePriceForTiers = parseInt(this.container.dataset.basePriceForTiers, 10);
        this.currentBasePrice = this.defaultBasePriceForTiers;
        this.skuListBody = this.container.querySelector('.sku-list-body');
        this.skuItems = this.container.querySelectorAll('.sku-item');
        this.totalItemsEl = this.container.querySelector('.js-total-items-count');
        this.totalPriceEl = this.container.querySelector('.js-total-price-value');
        this.addToCartBtn = this.container.querySelector('.b2b-add-to-cart-button');
        this.tierDisplayItems = this.container.querySelectorAll('.tier-item');
        
        const variantDataScript = this.container.querySelector('[data-product-variants-json]');
        try {
          this.productVariants = JSON.parse(variantDataScript.textContent);
        } catch(e) {
          this.productVariants = [];
          console.error("B2B Block: Failed to parse product variants JSON.", e);
        }
        
        this.mainPriceContainer = document.getElementById(`price-${this.container.dataset.sectionId}`);
        this.mediaGallery = document.querySelector(`media-gallery[id="MediaGallery-${this.container.dataset.sectionId}"]`);
        
        if (!this.skuListBody) return;
        this.updateTierPriceDisplay(this.defaultBasePriceForTiers);
        this.bindEvents();
        this.updateAll();
        this.initFancybox();
        this.handleVariantUrlOnLoad();
      }
  
      handleVariantUrlOnLoad() {
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        
        if (!variantId) return; 
  
        const targetSkuItem = this.container.querySelector(`.sku-item[data-variant-id="${variantId}"]`);
  
        if (targetSkuItem) {
          this.toggleSkuHighlight(targetSkuItem);
          
          setTimeout(() => {
              targetSkuItem.scrollIntoView({
                  behavior: 'smooth', 
                  block: 'center'
              });
          }, 100);
        }
      }
  
      initFancybox() {
        if (typeof Fancybox !== 'undefined') {
          Fancybox.bind(`[data-block-id="${this.container.dataset.blockId}"] [data-fancybox]`, {
            groupAll: true,
            caption: (fancybox, slide) => slide.triggerEl?.dataset.caption || null,
          });
        } else {
          console.warn('B2B BLOCK: Fancybox library is not loaded.');
        }
      }
  
      updateTierPriceDisplay(basePriceCents) {
        if (!basePriceCents || this.priceTiers.length === 0) return;
        this.currentBasePrice = basePriceCents;
        const priceRowItems = this.container.querySelectorAll('.tiers-row--header .tier-item');
        priceRowItems.forEach(item => {
          const tierPriceEl = item.querySelector('.tier-price');
          if (!tierPriceEl) return;
          let effectivePriceCents = basePriceCents;
          const discount = parseFloat(item.dataset.tierDiscount);
          const fixedPriceCents = parseFloat(item.dataset.tierPrice);
          if (this.isPercentageMode && !isNaN(discount)) {
            effectivePriceCents = Math.round(basePriceCents * (100 - discount) / 100);
          } else if (fixedPriceCents > 0) {
            effectivePriceCents = fixedPriceCents;
          }
          tierPriceEl.textContent = this.formatCurrency(effectivePriceCents) + this.priceUnit;
        });
      }
  
      bindEvents() {
        this.skuListBody.addEventListener('click', this.handleSkuListClick.bind(this));
        this.skuListBody.addEventListener('input', this.handleQuantityInputChange.bind(this));
        this.addToCartBtn.addEventListener('click', this.handleAddToCart.bind(this));
      }
  
      handleSkuListClick(event) {
        const target = event.target;
        const skuItem = target.closest('.sku-item');
        if (!skuItem) return;
        if (target.closest('.sku-image-link')) return; // Let Fancybox handle this
        if (target.matches('.qty-btn')) {
          event.preventDefault();
          event.stopPropagation();
          this.handleQuantityButtonClick(target);
          return;
        }
        if (!target.closest('.sku-quantity-control')) {
          this.toggleSkuHighlight(skuItem);
        }
      }
  
      syncThemeVariant(variantId) {
        if (!variantId || !this.productVariants.length || !this.mediaGallery) return;
        const variant = this.productVariants.find(v => v.id == variantId);
        if (!variant) return;
  
        if (variant.featured_media && typeof this.mediaGallery.setActiveMedia === 'function') {
          const mediaIdToActivate = `${this.container.dataset.sectionId}-${variant.featured_media.id}`;
          this.mediaGallery.setActiveMedia(mediaIdToActivate, true);
        }
  
        if (this.mainPriceContainer) {
          const priceWrapper = this.mainPriceContainer.querySelector('.price');
          if (priceWrapper) {
            const priceRegularContainer = priceWrapper.querySelector('.price__regular');
            const priceSaleContainer = priceWrapper.querySelector('.price__sale');
            if (priceRegularContainer && priceSaleContainer) {
              const regularPriceItem = priceRegularContainer.querySelector('.price-item');
              const salePriceItem = priceSaleContainer.querySelector('.price-item--sale');
              const compareAtPriceItem = priceSaleContainer.querySelector('s.price-item--regular');
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                if (compareAtPriceItem) compareAtPriceItem.textContent = this.formatCurrency(variant.compare_at_price);
                if (salePriceItem) salePriceItem.textContent = this.formatCurrency(variant.price);
                priceWrapper.classList.add('price--on-sale');
              } else {
                if (regularPriceItem) regularPriceItem.textContent = this.formatCurrency(variant.price);
                if (compareAtPriceItem) compareAtPriceItem.textContent = '';
                priceWrapper.classList.remove('price--on-sale');
              }
            }
          }
        }
        
        const mainFormInput = document.querySelector(`#product-form-${this.container.dataset.sectionId} input[name="id"]`);
        if (mainFormInput) { mainFormInput.value = variantId; }
  
        const productInfo = this.container.closest('product-info');
        if (productInfo && productInfo.dataset.updateUrl === 'true') {
          const url = new URL(window.location);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      }
      
      toggleSkuHighlight(clickedItem) {
        const isAlreadyHighlighted = clickedItem.classList.contains('is-highlighted');
        this.skuItems.forEach(item => { item.classList.remove('is-highlighted'); });
        
        if (!isAlreadyHighlighted) {
          clickedItem.classList.add('is-highlighted');
          const newBasePrice = parseInt(clickedItem.dataset.basePrice, 10);
          this.updateTierPriceDisplay(newBasePrice);
          this.syncThemeVariant(clickedItem.dataset.variantId);
        } else {
          this.updateTierPriceDisplay(this.defaultBasePriceForTiers);
          const firstAvailableVariant = this.productVariants.find(v => v.available) || this.productVariants[0];
          if (firstAvailableVariant) {
              this.syncThemeVariant(firstAvailableVariant.id);
          }
        }
      }
      
      handleQuantityButtonClick(button) {
        const action = button.dataset.action;
        const input = button.parentElement.querySelector('.qty-input');
        if (!input) return;
        let currentValue = parseInt(input.value, 10) || 0;
        if (action === 'increase') {
          input.value = currentValue + 1;
        } else if (action === 'decrease' && currentValue > 0) {
          input.value = currentValue - 1;
        }
        this.updateAll();
      }
  
      handleQuantityInputChange(event) {
        const target = event.target;
        if (!target.matches('.qty-input')) return;
        if (parseInt(target.value) < 0 || isNaN(parseInt(target.value))) {
          target.value = 0;
        }
        this.updateAll();
      }
  
      formatCurrency(amount) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang, {
            style: 'currency',
            currency: this.currencyCode
          }).format(amount / 100);
        } catch (e) {
          return `${(amount / 100).toFixed(2)}`;
        }
      }
  
      getActiveTier(totalQuantity) {
        const sortedTiers = [...this.priceTiers].sort((a, b) => b.qty - a.qty);
        return sortedTiers.find(tier => totalQuantity >= tier.qty);
      }
  
      updateAll() {
        let totalQuantity = 0;
        let grandTotalPriceCents = 0;
        this.skuItems.forEach(item => {
          const input = item.querySelector('.qty-input');
          if (input) {
            totalQuantity += parseInt(input.value, 10) || 0;
          }
        });
  
        const activeTier = this.getActiveTier(totalQuantity);
  
        this.skuItems.forEach(item => {
          const basePriceCents = parseInt(item.dataset.basePrice, 10);
          const quantity = parseInt(item.querySelector('.qty-input')?.value, 10) || 0;
          let effectivePriceCents = basePriceCents;
  
          if (activeTier && quantity > 0) {
            try {
              const tieredPricesData = JSON.parse(item.dataset.tieredPrices || '{}');
              if (tieredPricesData[activeTier.qty]) {
                effectivePriceCents = tieredPricesData[activeTier.qty];
              }
            } catch (e) {
              console.error("B2B Block: Could not parse tiered prices data.", e);
              effectivePriceCents = basePriceCents;
            }
          }
  
          if (quantity > 0) {
            grandTotalPriceCents += effectivePriceCents * quantity;
          }
  
          const priceDisplayEl = item.querySelector('.discounted-price');
          const originalPriceEl = item.querySelector('.original-price');
          const isDiscounted = activeTier && effectivePriceCents < basePriceCents;
  
          if (isDiscounted) {
            priceDisplayEl.textContent = this.formatCurrency(effectivePriceCents) + this.priceUnit;
            priceDisplayEl.classList.add('has-discount');
            originalPriceEl.textContent = this.formatCurrency(basePriceCents) + this.priceUnit;
            originalPriceEl.classList.add('is-discounted');
          } else {
            priceDisplayEl.textContent = this.formatCurrency(basePriceCents) + this.priceUnit;
            priceDisplayEl.classList.remove('has-discount');
            originalPriceEl.classList.remove('is-discounted');
          }
        });
  
        this.container.querySelectorAll('.tiers-row .tier-item').forEach(el => el.classList.remove('active-tier'));
        if (activeTier) {
          this.container.querySelectorAll(`.tier-item[data-tier-min="${activeTier.qty}"], .tier-item[data-tier-min-qty="${activeTier.qty}"]`).forEach(el => {
            el.classList.add('active-tier');
          });
        }
  
        this.totalItemsEl.textContent = totalQuantity;
        this.totalPriceEl.textContent = this.formatCurrency(grandTotalPriceCents);
        this.addToCartBtn.disabled = totalQuantity === 0;
      }
      
      handleAddToCart() {
        if (this.addToCartBtn.classList.contains('loading')) return;
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.classList.add('loading');
        const btnText = this.addToCartBtn.querySelector('.btn-text');
        const spinner = this.addToCartBtn.querySelector('.loading-spinner');
        const errorEl = this.container.querySelector('.error-message');
        
        btnText.style.opacity = '0.5';
        if (spinner) spinner.style.display = 'block';
        if (errorEl) errorEl.style.display = 'none';
  
        const itemsToAdd = [];
        this.skuItems.forEach(item => {
          const quantity = parseInt(item.querySelector('.qty-input')?.value, 10);
          if (quantity > 0 && item.dataset.variantAvailable === 'true') {
            itemsToAdd.push({ id: item.dataset.variantId, quantity: quantity });
          }
        });
  
        if (itemsToAdd.length === 0) {
          this.updateAll();
          this.addToCartBtn.classList.remove('loading');
          btnText.style.opacity = '1';
          if (spinner) spinner.style.display = 'none';
          return;
        }
  
        const cart = document.querySelector('cart-drawer');
        let sections = cart ? cart.getSectionsToRender().map(section => section.id) : ['cart-icon-bubble'];
        const body = {
          items: itemsToAdd,
          sections: sections,
          sections_url: window.location.pathname
        };
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
        .then(response => response.json())
        .then(state => {
          if (state.status) {
            throw new Error(state.description || 'An error occurred.');
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(state);
            if (typeof cart.open === 'function') {
              cart.open();
            }
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: state } }));
          }
        })
        .catch(error => {
          console.error('Add to Cart process failed:', error);
          if (errorEl) {
            errorEl.textContent = error.message;
            errorEl.style.display = 'block';
          }
        })
        .finally(() => {
          this.addToCartBtn.disabled = false;
          this.addToCartBtn.classList.remove('loading');
          btnText.style.opacity = '1';
          if (spinner) spinner.style.display = 'none';
        });
      }
    };
  }
  
  function initializeB2BBlocks() { 
    document.querySelectorAll('.b2b-product-block:not([data-initialized])').forEach(container => { 
      new window.B2BTieredPricing(container); 
    }); 
  }
  
  if (document.readyState === 'loading') { 
    document.addEventListener('DOMContentLoaded', initializeB2BBlocks); 
  } else { 
    initializeB2BBlocks(); 
  }
  
  document.addEventListener('shopify:section:load', function(event) { 
    const section = event.target; 
    if (section) { 
      section.querySelectorAll('.b2b-product-block:not([data-initialized])').forEach(container => { 
        new window.B2BTieredPricing(container); 
      }); 
    } 
  });
